import PropTypes from 'prop-types';
import { sitemapNavigationLinks } from '../constants/sitemapNavigationLinks';
import { linksEnabled } from '../constants/sitemapConstants';
import { getFilterUriType } from '../sitemapHelpers';

// components
import { Link } from 'dibs-elements/exports/Link';

// styles
import styles from '../styles/navigation.scss';

function getNavLinks(vertical = '') {
    const links = sitemapNavigationLinks.nav[vertical] || [];
    const verticalEnabledLinks = linksEnabled[vertical] || [];

    // Check nav item to make sure it's a valid facet and if link is usable or not
    return links.filter(({ label }) => verticalEnabledLinks.includes(label));
}

export const SitemapNavigation = ({ vertical, filterType }) => {
    const filterUriSegment = getFilterUriType(filterType);
    const currentUrl = `/sitemap/${vertical}/${filterUriSegment}/`;
    const staticLinks = getNavLinks(vertical);
    return (
        <ul className={styles.navigationList}>
            {staticLinks.map(({ href, title }) => {
                return (
                    <li key={href} className={styles.linkWrapper}>
                        <Link
                            href={href}
                            className={`${styles.link} ${
                                href === currentUrl ? styles.activeLink : ''
                            }`}
                        >
                            {title}
                        </Link>
                    </li>
                );
            })}
        </ul>
    );
};

SitemapNavigation.propTypes = {
    vertical: PropTypes.string.isRequired,
    filterType: PropTypes.string.isRequired,
};
